import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { ProposalClient } from "./ProposalClient";
import { ProposalAdmin } from "./ProposalAdmin";

export const ProposalPage = () => {
  const { isClient, isLoading } = useContext(AuthContext);

  let content: JSX.Element | JSX.Element[];
  if (isClient) {
    content = <ProposalClient />;
  } else {
    content = <ProposalAdmin />;
  }

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
